module.exports = "/_next/static/images/477bcf289079dcffde2b8fc4e5945cfa-loading-figures.svg.webp";